// extracted by mini-css-extract-plugin
export default {"description":"FacetFilter__description___b8jvp","items":"FacetFilter__items___KAiuF","item":"FacetFilter__item___iEEcU","count":"FacetFilter__count___TqRYE"};